class SceneData{

  constructor(){
    const scenes = [
      {
        id: '1',
        length: 220,
        type: 'autoplay',
      },
      {
        id: '2',
        length: 90,
        type: 'scrolling',
      },
      {
        id: '3',
        length: 91,
        type: 'scrolling',
      },
      {
        id: '4',
        length: 280,
        type: 'scrolling',
      },
      {
        id: '5',
        length: 145,
        type: 'scrolling',
      },
      {
        id: '6',
        length: 319,
        type: 'scrolling',
      },
      {
        id: '7',
        length: 146,
        type: 'scrolling',
      },
      {
        id: '8',
        length: 293,
        type: 'scrolling',
      },
      {
        id: '9',
        length: 143,
        type: 'scrolling',
      },
    ]

    const autoPlayPoints = [
      {startFrame: 0, endFrame: 220  },
      {startFrame: 682, endFrame: 802 },
      {startFrame: 1150, endFrame: 1269 },
      {startFrame: 1588, endFrame: 1701 },
      {startFrame: 2027, endFrame: 2145 },
      {startFrame: 2470, endFrame: 2588 },
      {startFrame: 2915, endFrame: 3030 },
      {startFrame: 3593, endFrame: 3677 },
    ]

    let frameCount = 0
    scenes.forEach((scene) => {
      scene.startFrame = frameCount
      frameCount += (scene.length)
    })

    this.data = {
      path: 'yes-master.json',
      frameCount: 3704,
      scenes: scenes,
      autoPlayPoints: autoPlayPoints,
      navigationPoints: this.getNavigationPoints(),
      sceneNames: this.getSceneNames(),
      menuDisplayStartFrame: 156,
    }
  }

  getSceneNames(){
    return(
      [
        {
          name: '01-157fr',
          path: 'data',
        },
        {
          name: '02-90fr',
          path: 'data',
        },
        {
          name: '03-91fr',
          path: 'data',
        },
        {
          name: '04-280fr',
          path: 'data',
        },
        {
          name: '05-145fr',
          path: 'data',
        },
        {
          name: '06-319fr',
          path: 'data',
        },
        {
          name: '07-146fr',
          path: 'data',
        },
        {
          name: '08-293fr',
          path: 'data',
        },
        {
          name: '09-143fr',
          path: 'data',
        },
        {
          name: '10-296fr',
          path: 'data',
        },
        {
          name: '11-148fr',
          path: 'data',
        },
        {
          name: '12-293fr',
          path: 'data',
        },
        {
          name: '13-148fr',
          path: 'data',
        },
        {
          name: '14-294fr',
          path: 'data',
        },
        {
          name: '15-148fr',
          path: 'data',
        },
        {
          name: '16-286fr',
          path: 'data',
        },
        {
          name: '17-93fr',
          path: 'data',
        },
        {
          name: '18-265fr',
          path: 'data',
        }
      ]
    )
  }

  getNavigationPoints(){
    return([
      0, 285, 345, 682, 980, 1150, 1462, 1588, 1900, 2027, 2341, 2470, 2786, 3382, 3409, 3593
    ])
  }

}
export default SceneData



// WEBPACK FOOTER //
// ./src/SceneData.js